import { LoadingOverlay } from "@shared/ui.components";
import { useUserContext } from "@shared/ui.hooks";
import React from "react";
import type { ReactNode } from "react";

import { MyAccountNavigation } from "../MyAccountNavigation/MyAccountNavigation";
import { ProfileHeader } from "../ProfileHeader/ProfileHeader";
import { ProfileNotification } from "../ProfileNotification/ProfileNotification";
import { ProfileNotificationProvider } from "../ProfileNotification/context";

import { wrapperStyle } from "./ProfileWrapper.css";

type Props = {
  children: ReactNode;
  title: string;
  loadingMessage: string;
  subheader?: string;
  pageBanner?: ReactNode;
  isLoading?: boolean;
};

export const ProfileWrapper = ({
  children,
  title,
  loadingMessage,
  subheader,
  pageBanner,
  isLoading = false
}: Props): JSX.Element => {
  const { isMember } = useUserContext();
  return (
    <>
      {pageBanner}
      <ProfileNotificationProvider>
        <ProfileNotification />
        <MyAccountNavigation variant="default" isMember={!!isMember} />
        <div className={wrapperStyle}>
          <ProfileHeader title={title} subheader={subheader} />
        </div>
        {isLoading ? <LoadingOverlay message={loadingMessage} /> : children}
      </ProfileNotificationProvider>
    </>
  );
};
